// extracted by mini-css-extract-plugin
module.exports = {"container":"PanelHeader_container__37vcc","wrapper":"PanelHeader_wrapper__2Y2kq","input":"PanelHeader_input__23enJ"};